import { WorkflowStep } from '../types/workflow';

// Step type templates for different categories
export const STEP_TYPE_TEMPLATES: Record<string, WorkflowStep> = {
  API_GET: {
    type: 10,
    name: "api-step",
    image: "ghcr.io/krnl-labs/executor-http@sha256:07ef35b261014304a0163502a7f1dec5395c5cac1fc381dc1f79b052389ab0d5",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: [
      {
        name: "url",
        type: "string",
        value: "https://jsonplaceholder.typicode.com/todos/1",
        required: true,
        description: "API endpoint URL"
      },
      {
        name: "method",
        type: "string",
        value: "GET",
        required: true,
        description: "HTTP method"
      },
      {
        name: "headers",
        type: "object",
        value: {
          "Accept": "*/*"
        },
        required: false,
        description: "HTTP headers",
        export: true
      }
    ],
    outputs: [
      {
        name: "response",
        type: "object",
        value: "response.body",
        required: true,
        export: true
      }
    ]
  },
  API_POST: {
    type: 10,
    name: "api-step",
    image: "ghcr.io/krnl-labs/executor-http@sha256:07ef35b261014304a0163502a7f1dec5395c5cac1fc381dc1f79b052389ab0d5",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: [
      {
        name: "url",
        type: "string",
        value: "https://jsonplaceholder.typicode.com/posts",
        required: true,
        description: "API endpoint URL"
      },
      {
        name: "method",
        type: "string",
        value: "POST",
        required: true,
        description: "HTTP method"
      },
      {
        name: "headers",
        type: "object",
        value: {
          "Accept": "*/*",
          "Content-Type": "application/json"
        },
        required: false,
        description: "HTTP headers"
      },
      {
        name: "body",
        type: "object",
        value: {
          "title": "foo",
          "body": "bar",
          "userId": 1
        },
        required: false,
        description: "Request body"
      }
    ],
    outputs: [
      {
        name: "response",
        type: "object",
        value: "response.body",
        required: true,
        export: true
      }
    ]
  },
  WEATHER_API: {
    type: 10,
    name: "weather-api",
    image: "ghcr.io/krnl-labs/executor-http@sha256:07ef35b261014304a0163502a7f1dec5395c5cac1fc381dc1f79b052389ab0d5",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: [
      {
        name: "url",
        type: "string",
        value: "https://api.openweathermap.org/data/2.5/weather?q=London&appid=YOUR_API_KEY",
        required: true,
        description: "OpenWeatherMap API endpoint"
      },
      {
        name: "method",
        type: "string",
        value: "GET",
        required: true,
        description: "HTTP method"
      },
      {
        name: "headers",
        type: "object",
        value: {
          "Accept": "application/json"
        },
        required: false,
        description: "HTTP headers"
      }
    ],
    outputs: [
      {
        name: "temperature",
        type: "number",
        value: "response.body.main.temp",
        required: true,
        export: true
      },
      {
        name: "description",
        type: "string",
        value: "response.body.weather[0].description",
        required: true,
        export: true
      },
      {
        name: "humidity",
        type: "number",
        value: "response.body.main.humidity",
        required: true,
        export: true
      }
    ]
  },
  NEWS_API: {
    type: 10,
    name: "news-api",
    image: "ghcr.io/krnl-labs/executor-http@sha256:07ef35b261014304a0163502a7f1dec5395c5cac1fc381dc1f79b052389ab0d5",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: [
      {
        name: "url",
        type: "string",
        value: "https://newsapi.org/v2/top-headlines?country=us&apiKey=YOUR_API_KEY",
        required: true,
        description: "NewsAPI endpoint"
      },
      {
        name: "method",
        type: "string",
        value: "GET",
        required: true,
        description: "HTTP method"
      },
      {
        name: "headers",
        type: "object",
        value: {
          "Accept": "application/json"
        },
        required: false,
        description: "HTTP headers"
      }
    ],
    outputs: [
      {
        name: "articles",
        type: "object[]",
        value: "response.body.articles",
        required: true,
        export: true
      },
      {
        name: "totalResults",
        type: "number",
        value: "response.body.totalResults",
        required: true,
        export: true
      }
    ]
  },
  CRYPTO_PRICE: {
    type: 10,
    name: "crypto-price",
    image: "ghcr.io/krnl-labs/executor-http@sha256:07ef35b261014304a0163502a7f1dec5395c5cac1fc381dc1f79b052389ab0d5",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: [
      {
        name: "url",
        type: "string",
        value: "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum&vs_currencies=usd",
        required: true,
        description: "CoinGecko API endpoint"
      },
      {
        name: "method",
        type: "string",
        value: "GET",
        required: true,
        description: "HTTP method"
      },
      {
        name: "headers",
        type: "object",
        value: {
          "Accept": "application/json"
        },
        required: false,
        description: "HTTP headers"
      }
    ],
    outputs: [
      {
        name: "bitcoin_price",
        type: "number",
        value: "response.body.bitcoin.usd",
        required: true,
        export: true
      },
      {
        name: "ethereum_price",
        type: "number",
        value: "response.body.ethereum.usd",
        required: true,
        export: true
      }
    ]
  },
  EVM_READ: {
    type: 10,
    name: "evm-data-fetcher",
    image: "ghcr.io/krnl-labs/executor-evm-read@sha256:9c15f3e004352f1062a22b8bf7d7fa80498449b9407bc6efc107dbdd7acce5a4",
    attestor: "https://public.mypinata.cloud/ipfs/bafybeid3msoebov6o54rtvjtrdwv7fg6tkeye2skrxh6jis25zok6pavzi",
    next: "construct-evm",
    config: {
      function_signature: "balanceOf(address)",
      input_parameters: [
        {
          name: "account",
          type: "address"
        }
      ],
      output_parameters: [
        {
          name: "balance",
          type: "uint256"
        }
      ]
    },
    inputs: {
      value: {
        account: "0x907089fC3966f52dB4463c8295Ad9aE3B164D94c"
      },
      url: "https://lb.drpc.org/optimism-sepolia/AnRM4mK1tEyphrn_jexSLbrPxqT4wGIR760VIlZWwHzR",
      chainid: 11155420,
      timeout: 30,
      contractAddress: "0xB9467B24117FD79D56F396ADC3cCDB695D905ae4"
    },
    outputs: [
      {
        name: "balance",
        value: "response.0",
        required: true,
        export: true
      }
    ]
  },
  EVM_CONSTRUCT: {
    name: "construct-evm",
    image: "ghcr.io/krnl-labs/executor-encoder-evm@sha256:b28823d12eb1b16cbcc34c751302cd2dbe7e35480a5bc20e4e7ad50a059b6611",
    attestor: "{{ENV.ATTESTOR_IMAGE}}",
    next: "prepare-authdata",
    config: {},
    inputs: {},
    outputs: []
  }
};

export const CONSTANT_STEPS: WorkflowStep[] = [];